// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"y_bJ"};